module.exports = __webpack_public_path__ + "static/pt-serif-v12-latin-700italic-c7652c04c56cb9bcdb567f541509e5b0.woff2";